<template>
  <div v-if="infoAvail" class="trainer-about">
    <div v-if="tr.age" class="line-info">
      <span>
        <i class="icon-age" />
        {{ $t('placeholder.age') }}
      </span>
      <p>{{ tr.age }} {{ getAgePrefix(tr.age) }}</p>
    </div>
    <div v-if="tr.languages.length" class="line-info">
      <span>
        <i class="icon-lang" />
        {{ $t('common.languages') }}
      </span>
      <p class="langs">
        {{ langs }}
      </p>
    </div>
    <div v-if="institutions.length" class="line-info">
      <span>
        <i class="icon-education" />
        {{ $t('common.study') }}
      </span>
      <div class="line-info-block">
        <p v-for="el in institutions" :key="el.id">
          {{ el.title }}
        </p>
      </div>
    </div>
    <div v-if="courses.length" class="line-info">
      <span>
        <i class="icon-courses" />
        {{ $t('common.courses') }}
      </span>
      <div class="line-info-block">
        <p v-for="el in courses" :key="el.id">
          {{ el.name }}
        </p>
      </div>
    </div>
    <div v-if="certifications.length" class="line-info">
      <span>
        <i class="icon-certificate" />
        {{ $t('common.certifications') }}
      </span>
      <div class="line-info-block">
        <p v-for="el in certifications" :key="el.id">
          {{ el.name }}
        </p>
      </div>
    </div>
  </div>
  <div v-else class="no-info">
    <div class="line-info">
      <p>{{ $t('common.no_trainer_about') }}</p>
    </div>
  </div>
</template>

<script>
import LangsMixin from '@/dependencies/mixins/profile/langs'
import AgePrefixMixin from '@/dependencies/mixins/profile/age-prefix'

export default {
  name: 'About',
  mixins: [LangsMixin, AgePrefixMixin],
  props: {
    tr: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    langs() {
      const ids = this.tr.languages.map((el) => el.id)
      return this.allLangs
        .filter((el) => ids.includes(el.id))
        .map((el) => el.name)
        .join(', ')
    },
    infoAvail() {
      const { age, languages, institutions, courses, certifications } = this.tr
      return !!(
        age ||
        languages.length ||
        institutions.length ||
        courses.length ||
        certifications.length
      )
    },
    courses() {
      return this.tr?.courses.filter((el) => el.name)
    },
    certifications() {
      return this.tr?.certifications.filter((el) => el.name)
    },
    institutions() {
      return this.tr?.institutions.filter((el) => el.title)
    }
  }
}
</script>

<style lang="scss">
@import '~assets/css/variables';

.trainer-about,
.trainer-achievements,
.no-info {
  .line-info {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }

    span {
      font-size: 13px;
      color: $gray;

      i {
        display: none;
      }
    }

    p {
      min-height: 40px;
      line-height: normal;
      font-size: 16px;
      padding: 10px;
      border-radius: 3px;
      border: solid 1px #f0f0f0;
      background-color: $gray-lighter;
      margin-bottom: 5px;
      color: #474747;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

@media (min-width: 768px) {
  .trainer-about,
  .trainer-achievements {
    .line-info {
      display: flex;

      &-block {
        width: 75%;
      }

      span {
        width: 25%;
        font-size: 18px;
        height: 43px;
        display: flex;
        align-items: center;

        i {
          display: block;
          font-size: 24px;
          color: $primary;
          margin-right: 6px;
        }
      }

      p {
        font-size: 18px;

        &.langs {
          width: 50%;
        }
      }
    }
  }
}
</style>
